// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";

/**
 *
 * @export
 * @interface BuildingFloodRiskOutput
 */
export interface BuildingFloodRiskOutput {
  /**
   *
   */
  buildingFloodRisk: RanaFile;
}

/**
 * Check if a given object implements the BuildingFloodRiskOutput interface.
 */
export function instanceOfBuildingFloodRiskOutput(value: object): value is BuildingFloodRiskOutput {
  if (
    (!("buildingFloodRisk" in (value as Record<string, any>)) &&
      !("building_flood_risk" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["buildingFloodRisk"] === undefined &&
      (value as Record<string, any>)["building_flood_risk"] === undefined)
  )
    return false;
  return true;
}

export function BuildingFloodRiskOutputFromJSON(json: any): BuildingFloodRiskOutput {
  return BuildingFloodRiskOutputFromJSONTyped(json, false);
}

export function BuildingFloodRiskOutputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BuildingFloodRiskOutput {
  if (json == null) {
    return json;
  }
  return {
    buildingFloodRisk: RanaFileFromJSON(json["building_flood_risk"]),
  };
}

export function BuildingFloodRiskOutputToJSON(json: any): BuildingFloodRiskOutput {
  return BuildingFloodRiskOutputToJSONTyped(json, false);
}

export function BuildingFloodRiskOutputToJSONTyped(
  value?: BuildingFloodRiskOutput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    building_flood_risk: RanaFileToJSON(value["buildingFloodRisk"]),
  };
}
